//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {};
  },
  methods: {
    openTab: function openTab() {
      //window.open('https://forms.monday.com/forms/embed/70fa34b59a65f7ac4e936ce1cd4677e0?r=use1', '_blank')
      window.open('https://forms.monday.com/forms/embed/5ca7ed444db01376168595c49379d596?r=use1', '_blank');
    }
  }
};